import { type IHotelState } from "../features/hotel/hotelInterface";

export const hotels = [
  {
    HotelCode: "AMS" as IHotelState["HotelCode"],
    Name: "CityHub Amsterdam",
    Id: import.meta.env.VITE_MEWS_AMS_ID as IHotelState["Id"],
    ConfigurationId: import.meta.env
      .VITE_MEWS_AMS_CONFIGURATION_ID as IHotelState["ConfigurationId"],
    DirectPaymentId: import.meta.env.VITE_MEWS_AMS_DP_RATE_ID as IHotelState["DirectPaymentId"],
    DefaultCulture: {
      LanguageCode: "en-US" as IHotelState["Culture"]["LanguageCode"],
      CultureCode: "US" as IHotelState["Culture"]["CultureCode"],
      CurrencyCode: "EUR" as IHotelState["Culture"]["CurrencyCode"],
    }
  },
  {
    HotelCode: "RTM" as IHotelState["HotelCode"],
    Name: "CityHub Rotterdam",
    Id: import.meta.env.VITE_MEWS_RTM_ID as IHotelState["Id"],
    ConfigurationId: import.meta.env
      .VITE_MEWS_RTM_CONFIGURATION_ID as IHotelState["ConfigurationId"],
    DirectPaymentId: import.meta.env.VITE_MEWS_RTM_DP_RATE_ID as IHotelState["DirectPaymentId"],
    DefaultCulture: {
      LanguageCode: "en-US" as IHotelState["Culture"]["LanguageCode"],
      CultureCode: "US" as IHotelState["Culture"]["CultureCode"],
      CurrencyCode: "EUR" as IHotelState["Culture"]["CurrencyCode"],
    }
  },
  {
    HotelCode: "CPH" as IHotelState["HotelCode"],
    Name: "CityHub Copenhagen",
    Id: import.meta.env.VITE_MEWS_CPH_ID as IHotelState["Id"],
    ConfigurationId: import.meta.env
      .VITE_MEWS_CPH_CONFIGURATION_ID as IHotelState["ConfigurationId"],
    DirectPaymentId: import.meta.env.VITE_MEWS_CPH_DP_RATE_ID as IHotelState["DirectPaymentId"],
    DefaultCulture: {
      LanguageCode: "en-US" as IHotelState["Culture"]["LanguageCode"],
      CultureCode: "US" as IHotelState["Culture"]["CultureCode"],
      CurrencyCode: "DKK" as IHotelState["Culture"]["CurrencyCode"],
    }
  },
  {
    HotelCode: "RKV" as IHotelState["HotelCode"],
    Name: "CityHub Reykjavik",
    Id: import.meta.env.VITE_MEWS_RKV_ID as IHotelState["Id"],
    ConfigurationId: import.meta.env
      .VITE_MEWS_RKV_CONFIGURATION_ID as IHotelState["ConfigurationId"],
    DirectPaymentId: import.meta.env.VITE_MEWS_RKV_DP_RATE_ID as IHotelState["DirectPaymentId"],
    DefaultCulture: {
      LanguageCode: "en-US" as IHotelState["Culture"]["LanguageCode"],
      CultureCode: "US" as IHotelState["Culture"]["CultureCode"],
      CurrencyCode: "EUR" as IHotelState["Culture"]["CurrencyCode"],
    }
  },
];
